// src/constants/theme.ts
// 統一的顏色系統和主題配置

import { TimeBoxCategory } from '../types/timeBox';
import { EventCategory } from '../types/calendar-event';

// 移除了 TIMEBOX_STYLES 和 EVENT_STYLES，改用純 Tailwind 類別

/**
 * =====================================
 * 類別顏色系統
 * =====================================
 */

// TimeBox 類別顏色 - 用於標籤圓點和文字
export const TIMEBOX_CATEGORY_COLORS: Record<TimeBoxCategory, string> = {
  focus: '#667EEA',    // 藍紫色
  routine: '#64748B',  // 灰藍色
  life: '#059669',     // 綠色
  rest: '#D97706'      // 橙色
};

// Event 類別顏色 - 用於標籤圓點和文字  
export const EVENT_CATEGORY_COLORS: Record<EventCategory, string> = {
  meeting: '#8B5CF6',      // 紫色
  appointment: '#3B82F6',  // 藍色
  class: '#059669',        // 綠色
  social: '#EC4899',       // 粉色
  deadline: '#EF4444',     // 紅色
  ceremony: '#F59E0B',     // 黃色
  anniversary: '#EC4899',  // 粉色
  holiday: '#10B981',      // 綠色
  competition: '#8B5CF6',  // 紫色
  other: '#64748B'         // 灰色
};

/**
 * =====================================
 * 類別標籤配置
 * =====================================
 */

// TimeBox 類別標籤配置
export const TIMEBOX_CATEGORY_CONFIG: Record<TimeBoxCategory, {
  label: string;
  color: string;
  dotColor: string;
}> = {
  focus: {
    label: 'FOCUS',
    color: '#667EEA',
    dotColor: '#667EEA'
  },
  routine: {
    label: 'ROUTINE', 
    color: '#64748B',
    dotColor: '#64748B'
  },
  life: {
    label: 'LIFE',
    color: '#059669',
    dotColor: '#059669'
  },
  rest: {
    label: 'REST',
    color: '#D97706', 
    dotColor: '#D97706'
  }
};

// Event 類別標籤配置
export const EVENT_CATEGORY_CONFIG: Record<EventCategory, {
  label: string;
  color: string;
  dotColor: string;
}> = {
  meeting: {
    label: 'MEETING',
    color: '#8B5CF6',
    dotColor: '#8B5CF6'
  },
  appointment: {
    label: 'APPOINTMENT',
    color: '#3B82F6',
    dotColor: '#3B82F6'
  },
  class: {
    label: 'CLASS',
    color: '#059669',
    dotColor: '#059669'
  },
  social: {
    label: 'SOCIAL',
    color: '#EC4899',
    dotColor: '#EC4899'
  },
  deadline: {
    label: 'DEADLINE',
    color: '#EF4444',
    dotColor: '#EF4444'
  },
  ceremony: {
    label: 'CEREMONY',
    color: '#F59E0B',
    dotColor: '#F59E0B'
  },
  anniversary: {
    label: 'ANNIVERSARY',
    color: '#EC4899',
    dotColor: '#EC4899'
  },
  holiday: {
    label: 'HOLIDAY',
    color: '#10B981',
    dotColor: '#10B981'
  },
  competition: {
    label: 'COMPETITION',
    color: '#8B5CF6',
    dotColor: '#8B5CF6'
  },
  other: {
    label: 'OTHER',
    color: '#64748B',
    dotColor: '#64748B'
  }
};

/**
 * =====================================
 * 工具函數
 * =====================================
 */

/**
 * 獲取 TimeBox 類別顏色配置
 */
export const getTimeBoxCategoryConfig = (category: TimeBoxCategory) => {
  return TIMEBOX_CATEGORY_CONFIG[category] || TIMEBOX_CATEGORY_CONFIG.focus;
};

/**
 * 獲取 Event 類別顏色配置
 */
export const getEventCategoryConfig = (category: EventCategory) => {
  return EVENT_CATEGORY_CONFIG[category] || EVENT_CATEGORY_CONFIG.other;
};

// 移除了 getCardStyles 函數，改用純 Tailwind 類別